import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledCharts = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(3),
  [theme.breakpoints.down('xmd')]: {
    flexDirection: 'column',
  },
}));
